import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from './utils/request.js';
import huakuai from 'huakuai-vue'
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import axios from 'axios'
Vue.prototype.$axios=axios;
Vue.use(VuePlyr, {
  plyr: {
    "object-fit": "contain", // 修正属性名和值
    autoplay: false,
    controls: ['play', 'progress', 'current-time', 'volume', 'fullscreen'],
    ratio: '9:16',
    muted: true,
  }
});

Vue.prototype.$axios = request;
Vue.use(ElementUI);
Vue.use(huakuai);

Vue.config.productionTip = false

// 添加处理 OSS URL 的全局方法
Vue.prototype.$processOssUrl = function(url) {
  if (!url) return '';
  
  // 如果是生产环境或URL不包含阿里云OSS域名，直接返回
  if (process.env.NODE_ENV !== 'development' || !url.includes('oss-cn-beijing.aliyuncs.com')) {
    return url;
  }
  
  // 在开发环境中，转换阿里云OSS URL为本地代理URL
  const ossPath = url.split('aliyuncs.com/')[1];
  if (ossPath) {
    return `/oss-videos/${ossPath}`;
  }
  return url;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
